import { Injectable } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/storage';

import { Observable } from 'rxjs';

import { RemoteAssetsService } from '../remote-assets.service';

@Injectable({
    providedIn: 'root',
})
export class FireStorageService implements RemoteAssetsService {
    constructor(private fireStorage: AngularFireStorage) {}

    getFileUrl(path: string): Observable<string> {
        return this.fireStorage.ref(path).getDownloadURL();
    }
}
